import Vue from 'vue';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import '@/plugins/icons';

Vue.use(Buefy);
